import React from 'react'
import styles from './InputForm.module.css'

const InputForm = ({type, name, id, classe, placeholder}) =>{


    return(
        <input type={type} name={name} id={id} className={`${classe} ${styles.input}`} placeholder={placeholder} ></input>
    )



}

export default InputForm